import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import * as moment from 'moment-timezone';
import { imageProcessing, ImageSnippet } from 'src/app/utils/image-processing-utils';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import { allowOnlyNumbersValidator, getFileNameFromUrl, onTimeChange, phoneNumberLengthValidator, uploadDocumentImages } from 'src/app/utils/utils.common';
import { error } from 'pdf-lib';
import { sweetAlert } from 'src/app/utils/swal';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { urls } from 'src/app/utils/url.utils';
import { validateFileSize } from 'src/app/utils/common.utils';
import { OnboardingMenu } from 'src/app/enums/enums';
import { addressValidator } from 'src/app/utils/custom-validators';
@UntilDestroy()

@Component({
  selector: 'app-add-driver',
  templateUrl: './add-driver.component.html',
  styleUrls: ['./add-driver.component.css']
})
export class AddDriverComponent implements OnInit {

  driverForm!: FormGroup;
  submitted = false;
  driverId: any;
  companyId: any;
  profileImageURL: any;
  signatureURL: any;
  selectedFile: ImageSnippet | null = null;
  signatureModalObj: any;

  // Edit Modal Inputs and Outputs
  @Input() driver: any;
  @Input() source: any;
  @Output() onSaveDriver = new EventEmitter<string>();
  @Output() onCloseModal = new EventEmitter<string>();
  // Edit Modal Inputs and Outputs End

  constructor(
    private uploadService: UploadService,
    private cedentialService: CredentialService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder
  ) { }

  ngOnInit() {


    this.driverForm = this.fb.group({
      firstName: ['', Validators.required],
      middleName: [''],
      lastName: ['', Validators.required],
      displayName: [''],
      address: this.fb.group({
        name: ['', Validators.required],
        coords: [[]],
        city: ['', Validators.required],
        state: ['', Validators.required],
      }, { validators: addressValidator() }),
      phoneNumber: ['', [Validators.required, phoneNumberLengthValidator]],
      contactNumber: ['', [Validators.required, phoneNumberLengthValidator]],
      email: ['', [Validators.required, Validators.email]],
      profileImageURL: [''],
      dob: ['', Validators.required],
      languageSpoken: ['', Validators.required],

      driverLicense: this.fb.group({
        image: [''],
        number: ['',Validators.required],
        issueDate: ['',Validators.required],
        expireDate: ['',Validators.required],
        stateIssue: ['']
      }),
      examinations: this.fb.group({
        phyExamImage: [''],
        phyExamDate: [''],
        phyExamExpireDate: [''],
        drugTestImage: [''],
        drugTestDate: [''],
        drugTestExpireDate: [''],
      }),
      abuse: [false],
      violations: [false],
      serviceAreas: [''],
      company: [''],
      signature: [''],
      attestation: ['', Validators.required],
      isActive: [false],
    }, {
      validators: [
        allowOnlyNumbersValidator('phoneNumber'),
        allowOnlyNumbersValidator('contactNumber'),
      ]
    });


    if (this.source === 'modal' && this.driver) {
      this.driverId = this.driver.id;
      this.companyId = this.driver.company;
      this.getDriverById();
    } else {

      this.driverId = this.route.snapshot.params['driverId'];
      this.companyId = this.route.snapshot.params['companyId'];
      if (this.driverId) {
        this.getDriverById();
      }

    }

    this.validateLinkedDates(this.driverLicense, 'issueDate', 'expireDate');
    this.validateLinkedDates(this.examinations, 'phyExamDate', 'phyExamExpireDate');
    this.validateLinkedDates(this.examinations, 'drugTestDate', 'drugTestExpireDate');

    this.driverForm.get('signature')?.valueChanges.pipe(untilDestroyed(this)).subscribe(value => {
      this.signatureURL = value;
    });
  }

  onSelectAddress(place: any): void {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.long_name : '';
    this.driverForm.patchValue({
      address: {
        city: cityName,
        state: stateName,
        name: place.formatted_address,
        coords: [
          place.geometry.location.lng(),
          place.geometry.location.lat()
        ]
      }
    });
  }

   validateLinkedDates(formGroup: FormGroup, startCtrl: string, endCtrl: string) {
    formGroup.valueChanges.subscribe(values => {
      const start = values[startCtrl];
      const end = values[endCtrl];

      const startControl = formGroup.get(startCtrl);
      const endControl = formGroup.get(endCtrl);

      if (start && end && new Date(start) >= new Date(end)) {
        endControl?.setErrors({ dateMismatch: true });
      } else {
        if (endControl?.hasError('dateMismatch')) {
          endControl.setErrors(null);
        }
      }
    });
  }


  get form() {
    return this.driverForm.controls;
  }

  get addressForm() {
    return this.driverForm.controls.address as FormGroup;
  }

  get driverLicense() {
    return this.driverForm.controls.driverLicense as FormGroup;
  }

  get examinations() {
    return this.driverForm.controls.examinations as FormGroup;
  }

  getDriverById() {
    this.cedentialService.getDriverById(this.driverId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.profileImageURL = data.profileImageURL;
        this.signatureURL = data.signature;
        this.driverForm.patchValue(data);
      }
    })
  }


  // profileImage

  processFile(imageInput: any) {
    const file = imageInput.files?.[0];
    if (!validateFileSize(file)) {
      return;
    }
    imageProcessing(imageInput).pipe(untilDestroyed(this)).subscribe({
      next: (result) => {
        this.selectedFile = result.file;
        if (!this.selectedFile || !(this.selectedFile instanceof Blob)) {
          console.error('Invalid file selected.');
          return;
        }
        this.uploadService.uploadImageToServer(this.selectedFile, urls.DRIVERS).pipe(untilDestroyed(this)).subscribe({
          next: (uploadResult: any) => {
            if (uploadResult?.fileUrl) {
              this.driverForm.get('profileImageURL')?.setValue(uploadResult.fileUrl);
              this.profileImageURL = uploadResult.fileUrl
              // this.profileImageURL = uploadResult.fileUrl; 
            }
          },
          error: (uploadError) => {
            console.error('Error uploading image:', uploadError);
          },
        });
      },
      error: (processingError) => {
        console.error('Error processing image:', processingError);
      },
    });
  }

  onSave() {
    this.submitted = true;
    this.driverForm.patchValue({
      company: this.companyId,
    });
    
    if (this.driverForm.invalid) return;
    
    let payload = this.driverForm.value;

    this.cedentialService.saveDrivers(this.driverId, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        // this.router.navigateByUrl(`/credentials/${this.companyId}`);
        if (this.source === 'modal') {
          this.onSaveDriver.emit(data);
        } else {
          this.router.navigate(['/credentials', this.companyId], { fragment: OnboardingMenu.DRIVERS });
        }
      }
    }, (err) => {
      sweetAlert("Error", err, "error", "OK");
    }
  )
  }

 
  
  // generic Method for upload docuemtns images

  uploadDocumentImages(documents: any, formControl: AbstractControl<any, any> | null) {
      const file = documents.files?.[0];
    if (!validateFileSize(file)) {
      documents.value = ''; // reset the file input
      return;
    }
    uploadDocumentImages(documents, formControl, this.uploadService, urls.DRIVERS)
  }

   getFileName(url: any) {
      return getFileNameFromUrl(url);
    }

  // Generic Datepicker method

  onDateChange(controlName: AbstractControl<any, any> | null) {
  onTimeChange(controlName)
  }

  deleteFile(formControl: AbstractControl<any, any> | null, fileInput: HTMLInputElement) {
    formControl?.setValue(null); // Safely calls setValue if formControl is not null
    if (formControl === this.driverForm.get('signature')) {
      this.signatureURL = null;
    }
    if (fileInput) {
      fileInput.value = '';
    }
  }

  getTimeRestrictions() {
    return {
      min: null,
      max: moment().endOf('day').toISOString()
    };
  }

  onChangeOwnerAddress(){
    this.driverForm.patchValue({
      address: {
          city: '',
        state: '',
        coords: ''
      }
    });
  }

  openSignatureModal() {
    this.signatureModalObj = { ...this.driverForm.value } || {};
  }

  onCloseSignatureModal(evt: any) {
    if (evt && evt.signature) {
      this.signatureURL = evt.signature;
      this.driverForm.patchValue({ signature: evt.signature });
    }
    this.signatureModalObj = null;
  }

  removeSignature() {
    this.signatureURL = null;
    this.driverForm.patchValue({ signature: '' });
  }

}
